export default "__VITE_ASSET__CHZYR3QC__"